import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { AxiosRequestConfig } from "axios";

export interface ApproveTempImageRequest {
  productId: number;
}

export interface ApproveTempImageResponse {}

export interface ApproveTempImagePathParameter {
  tempImageId: number;
}

export const approveTempImageTemplateUrl = `/product/temp_images/:tempImageId/approve`;

export const approveTempImageKey: YWRKey<ApproveTempImagePathParameter> =
  {
    url: (parameter) => {
      return calcUrl(approveTempImageTemplateUrl, parameter);
    },
    method: "put",
  };

export default function useApproveTempImage(
  config?: AxiosRequestConfig<ApproveTempImageRequest>
) {
  const fetcher = useFetcher<
    ApproveTempImageRequest,
    ApproveTempImageResponse
  >();
  return useYWR(approveTempImageKey, fetcher, {
    ...config,
    timeout: 3 * 60 * 1000,
  });
}
